import React, { useState } from 'react';
import backgroundVideo from './../earth.mp4';

const Loader = () => {
    const [videoLoaded, setVideoLoaded] = useState(false); // Track video loading

    return (
        <div
            style={{
                width: "100%",
                height: "100%",
                position: "relative",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                color: "#fff",
                fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                textAlign: "center",
                padding: "20px",
                overflow: "hidden",
                background: videoLoaded ? 'transparent' : '#000' // Black background until video loads
            }}
        >
            {/* Background Video */}
            <video
                autoPlay
                loop
                muted
                onLoadedData={() => setVideoLoaded(true)} // Set video as loaded
                onEnded={(e) => e.target.play()} // Restart video manually
                style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    filter: "blur(0px)",
                    zIndex: -1,
                    opacity: videoLoaded ? 1 : 0, // Hide video until loaded
                    transition: 'opacity 0.5s ease-in-out', // Smooth fade-in effect
                }}
            >
                <source src={backgroundVideo} type="video/mp4" />
                Your browser does not support the video tag.
            </video>

            {/* Loader Animation */}
            <div
                style={{
                    width: "80px",
                    height: "80px",
                    border: "8px solid #ccc",
                    borderTop: "8px solid #1e90ff",
                    borderRadius: "50%",
                    animation: "spin 1.5s linear infinite"
                }}
            />
            <br /><br />
            <div
                style={{
                    fontSize: "1.5rem",
                    marginBottom: "20px",
                    animation: "fadeInOut 2s ease-in-out infinite"
                }}
            >
                Reticulating splines... Hold on, we're magic-ing the data of Brahmand !
            </div>

            {/* CSS Animations */}
            <style>
                {`
                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
                @keyframes fadeInOut {
                    0%, 100% { opacity: 1; }
                    50% { opacity: 0.5; }
                }
                `}
            </style>
        </div>
    );
}

export default Loader;